var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-station"},[_vm._v("电站大屏")])
}
var staticRenderFns = []

export { render, staticRenderFns }